import React from "react";
import { Alert, Typography } from "@mui/material";

const ConflictResolutionAlert = () => (
  <Alert severity="info" sx={{ mb: 3 }}>
    <Typography variant="body2">
      <strong>Conflict Resolution:</strong> Review OSM data that might conflict with existing bars in the database.
      Select which fields to keep for each conflict. Red backgrounds indicate unresolved conflicts that must be addressed.
    </Typography>
  </Alert>
);

export default ConflictResolutionAlert;
